/**
 * Shared helpers for FE conversation-service chat clients
 * (template agent, AI analysts, future sheets/entity agents).
 */ export const CHAT_ATTACHMENT_MAX_COUNT = 10;
export const CHAT_ATTACHMENT_STATUS_POLL_MS = 500;
export const sleep = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
/** POST a file to an S3/MinIO presigned multipart form URL. */ export const postFileToS3Presigned = async (url, fields, file)=>{
    const formData = new FormData();
    Object.entries(fields !== null && fields !== void 0 ? fields : {}).forEach(([key, value])=>{
        formData.append(key, value);
    });
    // S3 requires the file field last.
    formData.append('file', file);
    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });
    if (!response.ok) {
        throw new Error(`S3 upload failed with status ${response.status}`);
    }
};
